import { createClient } from '@supabase/supabase-js';
import type { Database } from '@tool-factory/registry/types';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string;
if (!url || !anon) throw new Error('VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY required');

export const supabase = createClient<Database>(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

export const ADMIN_ALLOWED_EMAIL = import.meta.env.VITE_ADMIN_ALLOWED_EMAIL as string;
